import lifetouchCodeGuestLoginDirectiveHtml from 'html/claim/lifetouch-code-guest-login-directive.html';
import App from 'app/app.js';

function LtLifetouchCodeGuestLoginDirective() {
  return {
    restrict: 'E',
    scope: {
      backToSignIn: '&',
      onContinue: '&',
      jobLoadFailed: '<'
    },
    template: lifetouchCodeGuestLoginDirectiveHtml,
    controller: 'LtLifetouchCodeGuestLoginCtrl',
    controllerAs: 'lifetouchCodeGuestLogin'
  };
}

App.directive('ltLifetouchCodeGuestLogin', [LtLifetouchCodeGuestLoginDirective]);
